import React, { useEffect, useState } from "react";
import "./NachHistory.css";
import { nachHistories } from "../../services/merpservices";
import NachTickHist from "./NachTickHist";
import ServiceStoppedWithHover from "./ServiceStoppedWithHover";

const NachHistory = ({ empid, ak, glid, ecsIsActive }) => {
    const [data, setData] = useState(null);

    const nachHisotyJson = async () => {
        try {
            const res = await nachHistories(empid, glid, ak);
            if (res?.data?.status === 200) {
                setData(res?.data?.data?.listing_details?.[0] || null);
            }
        } catch (error) {
            console.error("Error fetching Nach history:", error);
        }
    };

    useEffect(() => {
        nachHisotyJson();
    }, []);

    const details = data?.nach_json?.Details;
    const serviceIds = [354, 228, 376];
    const availableServiceId = serviceIds.find((key) => details?.[key]);

    return (
        <div className="mb10">
            {availableServiceId && <NachTickHist data={data?.nach_json} />}
            {availableServiceId && (
                <ServiceStoppedWithHover dateStr={details?.[availableServiceId]?.Nach_stop_date} ecsIsActive={ecsIsActive}/>
            )}
        </div>
    );
};

export default NachHistory;